export enum ReviewSort {
  RatingDesc = 'rating_desc',
  RatingAsc = 'rating_asc',
  Relevancy = 'relevancy',
  SubmissionTimeDesc = 'submissiontime_desc',
  HelpfulnessDesc = 'helpfulness_desc',
}

export interface ProductReviewSummaryResponse {
  summary: string;
  rating: number;
  total_reviews: number;
  fit: SummaryFitData;
}

export interface SummaryFitData {
  rating: number;
  range: number;
  labels: string[];
}

export interface ReviewSortOption {
  label: string;
  value: ReviewSort;
}
export interface FetchReviewsParams {
  productHandle?: string;
  offset?: number;
  limit?: number;
  sort?: ReviewSort;
  feature?: string;
  q?: string;
  filters: AppliedReviewFilter[];
}

export interface FitInfo {
  rating: number;
  range: number;
  value_label: string;
  min_label: string;
  max_label: string;
}

export interface SecondaryInfo {
  label: string;
  value: string;
}

export interface Helpfulness {
  content_id: number;
  negative: number;
  positive: number;
}

export interface ReviewImage {
  normal?: string;
  thumbnail?: string;
  large?: string;
}

export interface ProductReview {
  title: string;
  text: string;
  rating: number;
  author: string;
  images?: ReviewImage[];
  fit?: FitInfo;
  secondary: SecondaryInfo[];
  helpfulness?: Helpfulness;
}

export interface FilterType {
  label: string;
  display_value: string;
}

export interface FilterOption {
  key: string;
  display_value: string;
}

export interface ReviewFilter {
  filtertype: FilterType;
  filteroptions: FilterOption[];
}

export interface ProductReviewsResponse {
  total_results: number;
  total_filtered_results?: number;
  reviews: ProductReview[];
  filters?: ReviewFilter[];
  features?: string[];
}

export type AppliedReviewFilter = {
  key: string;
  values: string[];
};

export enum ProductReviewVote {
  Positive = 'positive',
  Negative = 'negative',
}

export type ProductFeedbackType = ProductReviewVote | 'report';

export type ProductReviewVoteValue = 'p' | 'n';

export interface ProductReviewVoteData {
  c: number;
  v: ProductReviewVoteValue;
}

export type ProductReviewFeedbacks = Record<string, ProductReviewVoteData | boolean>;
